import { EnhancedOutgoingMessagesStatistic } from '@mm/state/model/ConnectedPageModel';

export const getMessage = (
  messagesStatistic: EnhancedOutgoingMessagesStatistic,
  period: string,
) => {
  const { utilizationPercentage, messagesRemaining } = messagesStatistic;

  if (utilizationPercentage > 99) {
    return `This page has exceeded the ${period} credits limit.`;
  }

  const messagesText = messagesRemaining === 1 ? 'credit' : 'credits';

  return `
    ${messagesRemaining} ${messagesText} remaining. Automations will be paused.
  `;
};
